import {
  Component,
  Input,
  NgZone,
  OnInit,
  OnDestroy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ExportService,
  LoggingService,
  PageOfManualsViewedData,
  PagesOfManualsViewedData,
  ToastrService,
} from "app/shared";
import {
  ChartDefinitions,
  ChartDefinition,
} from "../../../chartDefinitions.config";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { PagesViewedMostConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "pages-viewed-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class PagesViewedChartComponent
  extends BaseChartLogic<PagesViewedMostConfig, PagesOfManualsViewedData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      PagesViewedMostConfig,
      _ngZone
    );

    this.handleDataSubscription(
      this.analyticsService.pagesOfManualsViewedDataChange
    );
  }

  dataPointKey: string = "Total";
  protected getDataPointDisplayValue(dataPoint: PageOfManualsViewedData): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
    this.filterSettings.FilterByMinimum = this.config?.minViewed || null;
    //this.filterSettings.LimitResults = this.config?.top || null;
  }

  refreshData(): void {
    this.analyticsService.getPagesOfManualsViewedData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
